(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-harvest-row]').forEach(section => {
      if (section.dataset.harvestReady) return;
      section.dataset.harvestReady = 'true';
      const rail = section.querySelector('.ws-harvest-rail');
      const previous = section.querySelector('[data-harvest-scroll="-1"]');
      const next = section.querySelector('[data-harvest-scroll="1"]');
      if (!rail || !previous || !next) return;
      function update() {
        section.querySelector('.ws-harvest-controls').hidden = rail.scrollWidth <= rail.clientWidth + 2;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      }
      [previous, next].forEach(button => button.addEventListener('click', () => {
        const card = rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        const step = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({left: step * Number(button.dataset.harvestScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      rail.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

